import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Details = () => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section class="section shadow-sm lazyloaded" id="overview">
      <div class="over1">
        <h1 class="d-block section-heading color-primary text-capitalize">
          Dosti Greater Thane - Overview
        </h1>

        <p>
          Dosti Realty presents Dosti Greater Thane, a premium residential
          project located just 10 minutes from Viviana Mall and 6 minutes from
          Balkum, Thane. Developed by Dosti Realty, winner of the 'Developer of
          the Year 2020' by CNN-News18, this project promises modern living at
          an affordable price.
          <br />
          With state-of-the-art amenities, seamless connectivity, and superior
          infrastructure, this is your chance to own a home in Thane’s most
          sought-after address.
          <br />
        </p>
      </div>
      <center>
        <h3 style={{ fontSize: "1.2rem" }} className="mt-3">
          Dosti Greater Thane - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy">
              <li>
                <span> Prime Location – Excellent Connectivity</span>
              </li>
              <li>
                <span> Spacious 1 & 2 BHK Homes</span>
              </li>
              <li>
                <span>Indoor & Outdoor Lifestyle Amenities</span>
              </li>
              {/* <li>
                <span>20,000 Sqft of Clubhouse</span>
              </li> */}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy">
              <li>
                <span>Upcoming Metro Station Nearby</span>
              </li>
              <li>
                <span>Proposed ICSE School Within the Premises</span>
              </li>
              <li>
                <span> Nearby Upcoming Kalher Metro Station</span>
              </li>
              {/* <li>
                <span>Vibrant Night Life</span>
              </li> */}
            </ul>
          </div>
        </div>
      </div>
      <button
        class="chat-btn btn btn-info micro-form-btn effetMoveGradient enqModal download_brochure"
        onClick={handleShowModal}
      >
        <span class="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
